import { useMutation, useQueryClient } from "@tanstack/react-query";

import { usersQueryKey } from "@/hooks/queries/useGetUsers";
import { guacHttpClient } from "@/lib/http";
import { CreateInternalUserRequest, HttpResponse, User } from "@/types";

export function useCreateAddUser() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      createInternalUserRequest,
    }: {
      createInternalUserRequest: CreateInternalUserRequest;
    }) => {
      const path = "/users";
      const res = await guacHttpClient.post<
        User,
        HttpResponse<User>,
        CreateInternalUserRequest
      >(path, createInternalUserRequest);
      return res.data;
    },
    onSuccess: (newUser) => {
      queryClient.setQueryData(usersQueryKey(), (cachedData?: User[]) => {
        if (!cachedData) return [newUser];
        return [...cachedData, newUser];
      });
    },
  });
}
